// Components/Common/DashboardKit/useDebouncedValue.js
//
// R44 — small debounce hook used by the column-filter row so text-typing
// doesn't fire a server fetch on every keystroke. Returns the latest
// value after `delay` ms of stability.

import { useEffect, useState } from "react";

export default function useDebouncedValue(value, delay = 350) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(t);
    }, [value, delay]);
    return debounced;
}
